import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Typography, Divider, Icon, Grid } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { useNavigate } from "react-router-dom";

const SideMenuAccount = (props) => {
    const { closeMenu, signout, myAccount, email, firstName, lastName, phone, orgName } = props.value;
    const navi = useNavigate();

    const userDetails = JSON.parse(localStorage.getItem('tirefaxUserDetails'));

    const handleSignOut = () => {
        closeMenu('/');
        navi('/')
        signout();
    }

    return (
        <React.Fragment>
            <Typography variant="h6"
                sx={{
                    margin: '10px 0 10px 10px',
                    width: "97%",
                    minWidth: '150px'
                }}
            >Account Details</Typography>
            <Divider />
            <Grid container
                sx={{
                    margin: '10px 0 10px 10px',
                    width: "600px",
                    minWidth: '150px'
                }}
            >

                <Grid container item md={12}>
                    <Grid item md={3}><Typography variant="h2">Name:</Typography></Grid>
                    <Grid item md={1} />
                    <Grid item md={8}><Typography variant="h2">{`${userDetails.firstName} ${userDetails.lastName}` || ''}</Typography></Grid>
                </Grid>

                <Grid container item md={12}>
                    <Grid item md={3}><Typography variant="h2">E-Mail:</Typography></Grid>
                    <Grid item md={1} />
                    <Grid item md={8}><Typography variant="h2">{userDetails.email || ''}</Typography></Grid>
                </Grid>

                <Grid container item md={12}>
                    <Grid item md={3}><Typography variant="h2">Phone:</Typography></Grid>
                    <Grid item md={1} />
                    <Grid item md={8}><Typography variant="h2">{userDetails.phone || ''}</Typography></Grid>
                </Grid>

                <Grid container item md={12}>
                    <Grid item md={3}><Typography variant="h2">Organization:</Typography></Grid>
                    <Grid item md={1} />
                    <Grid item md={8}><Typography variant="h2">{userDetails.orgName || ''}</Typography></Grid>
                </Grid>

            </Grid>
            <Divider />
            <List sx={{ minWidth: '150px' }}>
                {
                    myAccount.map((text, index) =>
                        <ListItem button key={text.title} onClick={() => navi(text.onclick)}>
                            <ListItemIcon ><AddCircleIcon /></ListItemIcon>
                            <ListItemText primary={text.title} secondary={text.secTitle} />
                        </ListItem>
                    )
                }
                <Divider />
                <ListItem button onClick={handleSignOut}>
                    <ListItemIcon><PowerSettingsNewIcon /></ListItemIcon>
                    <ListItemText primary='Sign Out' />
                </ListItem>
            </List>
        </React.Fragment>
    )
}

export default SideMenuAccount;